/**
 * BrandInputs — the small set of semantic, plain-language controls the "Brand"
 * tier of the theme designer exposes. This is the SOURCE OF TRUTH for a site's
 * look; the full `Tokens` set is *derived* from it by `generate()` (never stored).
 *
 * Keep this list short and human ("brand color", "rounded corners") — not tokens.
 * Fields are additive-only: never remove/rename one (offline CRDT docs hold old
 * shapes forever — see docs/plans/2026-06-26-design-system-theme-token-designer.md, "Local-first").
 */
import * as Schema from "effect/Schema";

export const CornerRoundness = Schema.Literal(
  "none",
  "subtle",
  "rounded",
  "pill",
);
export type CornerRoundness = Schema.Schema.Type<typeof CornerRoundness>;

export const Density = Schema.Literal("compact", "comfortable", "spacious");
export type Density = Schema.Schema.Type<typeof Density>;

export const BrandInputs = Schema.Struct({
  /** Seed color — drives the generated primary palette. Any CSS color string. */
  brandColor: Schema.String,
  /** Secondary emphasis color. */
  accentColor: Schema.String,
  /** Font family name for headings (validated against a curated list at the UI boundary). */
  headingFont: Schema.String,
  /** Font family name for body text. */
  bodyFont: Schema.String,
  /** How rounded corners are across the site. */
  cornerRoundness: CornerRoundness,
  /** Overall spacing density. */
  density: Density,
});
export type BrandInputs = Schema.Schema.Type<typeof BrandInputs>;
